<template>
  <div class="edit-tag-dialog">
    <el-form ref="form" :model="formData" :rules="formRules" label-width="100px" label-position="top" class="flex-1">
      <el-form-item label="Feedback" prop="feedback">
        <el-input
          type="textarea"
          v-model="formData.feedback"
          placeholder="Write feedback here..."
          :autosize="{ minRows: 6 }"
          class="w-full"
        />
      </el-form-item>
    </el-form>
    <div class="flex flex-row justify-end">
      <el-button type="primary" @click="handleConfirm">Confirm</el-button>
      <el-button type="default" @click="handleCancel">Cancel</el-button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["confirm", "cancel"],
  props:{
    value:{ type: String, default: ""}
  },
  data() {
    return {
      formData: {
        feedback: this.value,
      },
      formRules: {
        feedback: [
          { required: true, message: "Feedback is required.", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("confirm", this.formData.feedback);
        }
      });
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
.edit-tag-dialog {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
